// src/App.jsx
import React from 'react';
import { initializeApp } from 'firebase/app';
import { ThemeProvider } from 'next-themes';
import DSAPlatform from './components/DSAPlatform';
import './styles/globals.css';
import { firebaseConfig } from './config/firebase';

// Initialize Firebase
initializeApp(firebaseConfig);

function App() {
  return (
    <ThemeProvider 
      attribute="class" 
      defaultTheme="dark"
      enableSystem={true}
    >
      <div className="min-h-screen bg-background text-foreground transition-colors duration-300">
        <DSAPlatform />
      </div>
    </ThemeProvider>
  );
}

export default App;